import React, { FunctionComponent } from "react";
import styles from "./ModalButtonWrapper.module.scss";

export const ModalButtonWrapper: FunctionComponent<{}> = ({children}) => {
  return  <div className={styles.buttonWrapper}>{children}</div>
}